import { useEffect } from 'react';
import { BrowserRouter } from 'react-router';

import { AppProviders } from '@/app/providers/AppProviders';
import { AppRouter } from '@/app/router';
import { useAuthStore } from '@/store/auth.store';

export function App() {
  const initialize = useAuthStore((state) => state.initialize);

  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <AppProviders>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AppProviders>
  );
}
